import { getAxios } from '@parchment/oauth2-axios';
import { ADDRESS_VERIFICATION_API_RESOURCE_KEY } from './constants';
export default async function getListOfCountryCodes() {
  let root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  const response = await getAxios(ADDRESS_VERIFICATION_API_RESOURCE_KEY).get(`${root}countries`);
  return response.data || [];
}